import React, { useState } from 'react';

import { LoginFormData, LoginFormProps } from '@/Login/types/authTypes';

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, loading = false }) => {
  const [formData, setFormData] = useState<LoginFormData>({
    email: '',
    password: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="mb-12 flex flex-col gap-5">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Email"
          className="h-12 w-full rounded border border-[#ddd] px-6 text-base font-normal text-[#222] outline-none placeholder:text-base placeholder:font-normal placeholder:text-[#aaa] focus:border-[#95699f]"
          required
        />
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          placeholder="Password"
          className="h-12 w-full rounded border border-[#ddd] px-6 text-base font-normal text-[#222] outline-none placeholder:text-base placeholder:font-normal placeholder:text-[#aaa] focus:border-[#95699f]"
          required
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        className="h-12 w-full rounded-lg bg-[#95699f] text-lg font-bold text-white transition-colors duration-200 hover:bg-[#81528e] disabled:cursor-not-allowed disabled:opacity-50"
      >
        {loading ? 'SIGNING IN...' : 'SIGN IN'}
      </button>
    </form>
  );
};

export default LoginForm;
